const convertFormDataToJson = require("./convertFormDataToJson");

/**
 * @param form {HTMLFormElement}
 * @return {{[field: string]: string}}
 */
module.exports = function getFormDataAsJson(form) {
    const formData = new FormData(form);
    return convertFormDataToJson(formData);
}